<div class="related-resource-card">
  <div class="related-resource-card-title">
    {{ title }}
  </div>
  <div class="related-resource-card-status" *ngIf="parentInput().relatedResourceInfo">
    <div>
      {{ 'inventoryResourcePage.relatedResourceCardStatusTitle' | labelsProvider }}
    </div>
    <app-status-label [statusLabel]="parentInput().relatedResourceInfo?.resourceStatus ?? ''"></app-status-label>
  </div>
  <app-card-fields [cardFields]="fields" [isToggleContentAllowed]="isToggleContentAllowed()"> </app-card-fields>

  <div *ngIf="additionalInfoFields.length > 0" class="additional-info-card">
    <app-accordion
      class="related-resource-card-title"
      accordionTitle="inventoryResourcePage.additionalInfoCardTitle"
      [boldTitle]="true"
      [withLabelPipe]="true"
      [expanded]="relationBodyExpansionState"
      (accordionExpansionEvent)="updateRelationBodyAccordionExpansionState($event)"
    >
      <app-card-fields
        [cardFields]="additionalInfoFields"
        [isToggleContentAllowed]="isToggleContentAllowed()"
      ></app-card-fields>
    </app-accordion>
  </div>

  @if (parentInput().relatedResourceInfo) {
    <a class="explore-resource-link" (click)="onExploreResourceClick($event)">
      {{ 'inventoryResourcePage.relatedViolationCardExploreResourceLink' | labelsProvider }}
      <img src="assets/images/arrows/empty-arrow-right.svg" class="explore-resource-link__icon" />
    </a>
  }

  <div *ngIf="!parentInput().relatedResourceInfo" class="related-resource-card-broken-relation">
    <div>
      {{ 'inventoryResourcePage.brokenRelationDisclaimer' | labelsProvider }}
    </div>
    <app-anchor-link navigation="/app/support">
      {{ 'inventoryResourcePage.contactSupport' | labelsProvider }}
    </app-anchor-link>
  </div>
</div>
